module.exports = __webpack_public_path__ + "img/b71ee19.jpg";